//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    story: { type: Object, required: true }
  },
  computed: {
    title () {
      return {
        'pro-team': 'Pro Team',
        video: 'Video',
        news: 'News',
        instagram: 'Instagram'
      }[this.story.category] || 'Stories'
    }
  }
}
